var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('header', {
    directives: [{
      name: "scroll",
      rawName: "v-scroll",
      value: _vm.fixedScroll,
      expression: "fixedScroll"
    }],
    staticClass: "header header--fixed"
  }, [_c('div', {
    staticClass: "header__body"
  }, [_c('v-container', [_c('h1', {
    staticClass: "header__logo"
  }, [_c('a', {
    attrs: {
      "href": "/",
      "title": "Home"
    }
  }, [_c('span', {
    staticClass: "d-sr-only"
  }, [_vm._v("Meitextile")])])]), _c('div', {
    staticClass: "header__contents"
  }, [_c('div', {
    staticClass: "header__gnb justify-end"
  }, [_c('client-gnb', {
    attrs: {
      "className": "gnb"
    }
  }), _c('div', {
    staticClass: "lang-wrap d-none d-xl-flex"
  }, [_c('div', {
    staticClass: "lang-btn"
  }, [_c('v-btn', {
    staticClass: "transparent",
    attrs: {
      "icon": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "size": "30",
      "color": "#fff"
    }
  }, [_vm._v("mdi-web")])], 1)], 1), _c('ul', {
    staticClass: "lang"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/ko"
    }
  }, [_vm._v("KR")])], 1), _c('li', {
    staticClass: "on"
  }, [_c('span', [_vm._v("EN")])])])])], 1), _c('div', {
    staticClass: "d-xl-none mt-30"
  }, [_c('v-row', {
    attrs: {
      "no-gutters": "",
      "justify": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-btn', {
    staticClass: "min-w-auto",
    attrs: {
      "text": "",
      "to": "/ko",
      "color": "grey"
    }
  }, [_vm._v("KR")])], 1), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-btn', {
    staticClass: "min-w-auto cursor-default",
    attrs: {
      "text": ""
    }
  }, [_vm._v("EN")])], 1)], 1)], 1)])])], 1), _vm._m(0)]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "hamburger-btn"
  }, [_c('span')]);
}]

export { render, staticRenderFns }